<template>
  <div
    ref="convstooltip"
    class="con-vs-tooltip"
    @click.self="handleClick"
    @mouseleave="onMouseLeave"
    @mouseenter="onMouseEnter"
  >
    <transition name="tooltip-fade">
      <div
        v-show="active"
        :id="id"
        ref="vstooltip"
        :class="[`vs-tooltip-${positionx || position}`,`vs-tooltip-${color}`, {'after-none': noneAfter}]"
        :style="style"
        class="vs-tooltip">
        <h4 v-if="title">{{ title }}</h4>
        {{ text }}
      </div>
    </transition>
    <slot />
  </div>
</template>

<script>
import { v4 as uuidv4 } from 'uuid'
import utils from '@/assets/utils'
import _color from '@/assets/utils/color.js'
export default {
  name:'VxTooltip',
  props:{
    title:{
      default:null,
      type:[String,Number]
    },
    text:{
      default:null,
      type:[String,Number]
    },
    color:{
      default:null,
      type:String
    },
    position:{
      default:'top',
      type:String
    },
    delay:{
      default:'0s',
      type:[Number,String]
    }
  },
  data () {
    return {
      cords:{},
      active:false,
      width: 'auto',
      positionx: null,
      noneAfter: false,
      id: null,
    }
  },
  computed:{
    style(){
      return {
        left:this.cords.left,
        top:this.cords.top,
        transitionDelay: this.active?this.delay:'0s',
        background:_color.getColor(this.color,1),
        width: this.width
      }
    }
  },
  created () {
    this.id = `tooltip-${uuidv4()}`
  },
  destroyed () {
    const obj = document.querySelector(`#${this.id}`)

    if (obj) {
      utils.removeBody(obj)
    }
  },
  methods:{
    onMouseEnter () {
      this.active = true

      this.$nextTick(()=>{
        utils.insertBody(this.$refs.vstooltip)
        this.changePosition(this.$refs.convstooltip,this.$refs.vstooltip)
      })
    },
    onMouseLeave () {
      this.active = false

      this.$nextTick(() => {
        utils.removeBody(this.$refs.vstooltip)
      })
    },
    changePosition(elxEvent, tooltip){
      this.noneAfter = false
      this.positionx = null

      const elx = elxEvent.closest('.con-vs-tooltip')
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      let top = elx.getBoundingClientRect().top + scrollTop - tooltip.clientHeight - 4
      let left = elx.getBoundingClientRect().left - tooltip.clientWidth / 2 + elx.clientWidth / 2
      let width = elx.clientWidth

      if(this.position == 'bottom'){
        top = elx.getBoundingClientRect().top + scrollTop + elx.clientHeight + 4
      } else if (this.position == 'left') {
        left = elx.getBoundingClientRect().left - tooltip.clientWidth - 4
        top = elx.getBoundingClientRect().top + scrollTop + (elx.clientHeight / 2) - (tooltip.clientHeight / 2)
        if (Math.sign(left)==-1) {
          left = elx.getBoundingClientRect().left
          top = elx.getBoundingClientRect().top + scrollTop + elx.clientHeight + 4
          this.positionx = 'bottom'
          this.noneAfter = true
        }
      } else if (this.position == 'right') {
        left = elx.getBoundingClientRect().left + elx.clientWidth + 4
        top = elx.getBoundingClientRect().top + scrollTop + (elx.clientHeight / 2) - (tooltip.clientHeight / 2)
        if( window.innerWidth - (left + tooltip.clientWidth) <= 20) {
          left = elx.getBoundingClientRect().left - tooltip.clientWidth / 2 - 10
          top = elx.getBoundingClientRect().top + scrollTop + elx.clientHeight + 4
          this.positionx = 'bottom'
          this.noneAfter = true
        }
      }
      this.cords = {
        left: `${left}px`,
        top: `${top}px`,
        width: `${width}px`
      }
    }
  }
}
</script>
